/* RESPONSIBLE TEAM: team-reporting */

import type { ChartSeries } from '@/features/reporting-charts/types';

const AGGREGATION_LABELS: Record<string, string> = {
  mean: 'Average',
  median: 'Median',
  min: 'Minimum',
  max: 'Maximum',
  sum: 'Sum',
};

/**
 * Returns the display name for a chart series, matching Ember's chart-series model:
 *
 * 1. If `label` is set (user override), return it directly.
 * 2. If `aggregation` has a known prefix, return `${prefix} ${metricDisplayName}`.
 * 3. Otherwise return `metricDisplayName` or the fallback.
 */
export function getDisplayNameWithAggregation(
  chartSeries: ChartSeries | undefined,
  fallbackName?: string,
): string | undefined {
  if (chartSeries?.label) {
    return chartSeries.label;
  }

  const baseName = chartSeries?.metricDisplayName ?? fallbackName;
  if (!baseName) return undefined;

  const aggregation = chartSeries?.aggregation;
  const prefix = aggregation ? AGGREGATION_LABELS[aggregation] : undefined;

  if (prefix) {
    return `${prefix} ${baseName}`;
  }

  return baseName;
}
